'use strict';

function isUndefined(o) {
  return o === undefined;
}

module.exports = isUndefined;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/isUndefined.js
// module id = 9
// module chunks = 0